export default () => ({
  MuiCssBaseline: {
    '@global': {
      body: {
        backgroundColor: '#F1F1F1'
      }
    }
  }
})
